import * as yup from 'yup'
import constants from 'constants/index'

const { STORAGE_DEFINED_TYPE, STORAGE_PERMANENT_TYPE } = constants.dataProcess

const dataLifeCycleSchema = () => {
  return yup.object().shape({
    dataLifeCycleId: yup.string(),
    retentionFinality: yup.string().required(),
    internalAllocationModeId: yup.string().required(),
    protectionId: yup.string().required(),
    recoveryId: yup.string().required(),
    storageType: yup.number().typeError('Preencha esse campo').required(),
    discardModeId: yup.string().when(['storageType'], {
      is: (storageType) => storageType !== STORAGE_PERMANENT_TYPE,
      then: yup.string().required(),
    }),
    value: yup.number().when('storageType', {
      is: STORAGE_DEFINED_TYPE,
      then: yup.number().typeError('Precisa ser um número').required(),
    }),
    volumetry: yup.string().when('storageType', {
      is: STORAGE_DEFINED_TYPE,
      then: yup.string().required(),
    }),
    anotherAssetInventory: yup.string().max(255).required(),
    anotherDiscardMode: yup.string().when('discardModeId', {
      is: 'another',
      then: yup.string().required(),
    }),
    anotherRecovery: yup.string().when('recoveryId', {
      is: 'another',
      then: yup.string().required(),
    }),
    assetInventoryCategory: yup
      .object()
      .shape({
        id: yup.number().required(),
        name: yup.string().required(),
      })
      .required()
      .typeError('Preencha esse campo'),
    assetInventory: yup
      .object()
      .shape({
        id: yup.number().required(),
        name: yup.string().required(),
      })
      .nullable()
      .typeError('Preencha esse campo'),
  })
}

export default dataLifeCycleSchema
